import Navbar from '../components/Navbar';
import HeroBanner from '../components/HeroBanner';
import HeroIntro from '../components/HeroIntro';
import EverythingSection from '../components/EverythingSection';
import PartnersSection from '../components/PartnersSection';
import FoundationalTech from '../components/FoundationalTech';
import StatsSection from '../components/StatsSection';
import CodeShowcase from '../components/CodeShowcase';
import ActionCards from '../components/ActionCards';
import CommunityGallery from '../components/CommunityGallery';
import NewsletterSection from '../components/NewsletterSection';
import NewsCarousel from '../components/NewsCarousel';
import Footer from '../components/Footer';
import { WalletModalProvider } from '../components/WalletModalContext';
import ConnectWalletModal from '../components/ConnectWalletModal';
import { ChatProvider } from '../context/ChatContext';
import LiveSupportButton from '../components/LiveSupportButton';
import ChatWidget from '../components/ChatWidget';
import '../App.css';

function LandingPage() {
  return (
    <WalletModalProvider>
      <ChatProvider>
        <div className="App">
          <Navbar />
          <HeroBanner />
          <HeroIntro />
          <EverythingSection />
          <PartnersSection />
          <FoundationalTech />
          <NewsCarousel />
          <StatsSection />
          <CodeShowcase />
          <ActionCards />
          <CommunityGallery />
          <NewsletterSection />
          <Footer />
          <ConnectWalletModal />
          <LiveSupportButton />
          <ChatWidget />
        </div>
      </ChatProvider>
    </WalletModalProvider>
  );
}

export default LandingPage;